export default __webpack_public_path__ + "static/media/10.5ae9b5d2.jpg";